import request from '@/utils/request'
// profile页面
export function lockin(query) {
  return request({
    url: '/starter/lockin',
    method: 'get',
    params: query
  })
}
// Pools页面
export function perviousProjectsV2(query) {
  return request({
    url: '/starter/perviousProjectsV2',
    method: 'get',
    params: query
  })
}

export function getSid(query) {
  return request({
    url: '/starter/getSid',
    method: 'get',
    params: query
  })
}

// 参与页面
export function deposit(query) {
  return request({
    url: '/starter/depositV2',
    method: 'get',
    params: query
  })
}

export function apply(query) {
  return request({
    url: '/starter/apply',
    method: 'post',
    params: query
  })
}


export function depositIno(query) {
  return request({
    url: '/starter/depositIno',
    method: 'post',
    params: query
  })
}

export function perviousIno(query) {
  return request({
    url: '/starter/perviousIno',
    method: 'post',
    params: query
  })
}

export function addSource(query) {
  return request({
    url: '/starter/addSource',
    method: 'post',
    params: query
  })
}







// WEBPACK FOOTER //
// ./src/utils/api.js